import { combineReducers } from '@reduxjs/toolkit'
import menuReducer from '../Pages/Menu/MenuSlice'
// import searchReducer from './searchReducer'


export const rootReducers = combineReducers({
    menu: menuReducer,
    // add reducers here
    // search : searchReducer
})